var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 144 112",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7941D;}\n"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00451695919, 0, 0, 0.995997905731, -188.800034959619, -144.975051571986)",
    style: {
      transformOrigin: "260.8px 200.975px"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.7,213.3h12.8c2.3,0,4.2,1.8,4.2,4.1v12.3c0,2.3-1.9,4.1-4.2,4.1h-12.8c-2.3,0-4.2-1.8-4.2-4.1v-12.3 C282.5,215.1,284.3,213.3,286.7,213.3z M235,233.8h-12.8c-2.3,0-4.2-1.8-4.2-4.1v-12.3c0-2.3,1.9-4.1,4.2-4.1H235 c2.3,0,4.2,1.8,4.2,4.1v12.3C239.2,232,237.3,233.8,235,233.8z M207.3,208.4V251c0,3.4,2.8,6.2,6.3,6.2H244c3.5,0,6.3-2.8,6.3-6.2 v-31.5c0-3.4,2.8-6.2,6.3-6.2h8.6c3.5,0,6.3,2.8,6.3,6.2V251c0,3.4,2.8,6.2,6.3,6.2H308c3.5,0,6.3-2.8,6.3-6.2v-42.6 c0-1.7-0.7-3.4-2-4.5l-47.2-42.6c-2.4-2.2-6.1-2.2-8.5,0l-47.2,42.6C208.1,205,207.3,206.7,207.3,208.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.6,177.9v-24.7c0-3.4-2.8-6.2-6.3-6.2h-2.2c-3.5,0-6.3,2.8-6.3,6.2v11.4l-17.4-15.8 c-6-5.4-15.2-5.4-21.2,0l-59.9,54.1c-1.5,1.4-1.6,3.7-0.1,5.1l0,0c1.4,1.3,3.6,1.4,5,0.1l59-53.3c3.8-3.4,9.5-3.4,13.3,0l59,53.2 c1.4,1.3,3.6,1.2,4.9-0.1l0,0c1.5-1.4,1.4-3.8-0.1-5.1L303.6,177.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/House_Icon.aa5c3c0a7becb6a444dcdc2597b65225.svg";
export { ForwardRef as ReactComponent };